import {Injectable} from '@angular/core';
import {Events} from 'ionic-angular';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';

// Providers
import {IEmployee} from './employee.service';

// Interfaces
export interface IProjectType {
    id: number;
    prefix: string;
    name: string;
    description: string;
}

export interface IProjectStatus {
    id: number;
    name: string;
    description: string;
}

export interface IProject {
    id: number;
    name: string;
    jobnumber: number;
    projecttype: IProjectType;
}

export interface IProjectDetails {
    id: number;
    name: string;
    jobnumber: number;
    address: string;
    city: string;
    state: string;
    zipcode: number;
    hidden: boolean;
    superintendent: IEmployee;
    status: IProjectStatus;
    projecttype: IProjectType;
}

@Injectable()
export class rsProjectSvc {

    constructor( private http: Http, private events: Events ) 
    {
        
    }
    getProjects( filter: string = "visible" ) : Observable<IProject[]> {
        // Return our observable
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/projects/filters/' + filter, {
                withCredentials: true
            })
            .map( res => {
                return res.json().response.projects;
            })
            .subscribe( result => {
                // operation successful
                observer.next(result);
            }, err=> {
                // error encountered
                observer.error(err);
            }, () => {
                // operation complete
                observer.complete();
            });
        });
    }
    getProject( id: number ) : Observable<IProjectDetails> {
        // Return observable object
        return Observable.create( observer => {
            // This method gets run when an object subscribes
            this.http.get( 'http://dfr.hydrocon.com/api/v1/projects/' + id, {
                withCredentials: true
            })
            .map( res => res.json().response ) 
            .subscribe( result => {
                // Request was successful
                observer.next(result);
            }, err => {
                // Request failed
                observer.error(err);
            }, () => {
                // Request completed
                observer.complete();
            });
        });
    }
    addProject( jobnumber: number, name: string, address: string, city: string, 
                state: string, zipcode: number, statusid: number, superintendentid: number, 
                projecttypeid: number, hidden: boolean 
    ) : Observable<IProjectDetails> 
    {
        // Return observable object 
        return Observable.create( observer => {
            // Assemble our post data object
            let postData = {
                jobnumber: jobnumber,
                name: name,
                address: address,
                city: city,
                state: state,
                zipcode: zipcode,
                statusid: statusid,
                superintendentid: superintendentid,
                projecttypeid: projecttypeid,
                hidden: hidden ? 1 : 0
            };

            // Build our HTTP request 
            let body = JSON.stringify(postData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.post( 'http://dfr.hydrocon.com/api/v1/projects', body, options )
            .map( res => res.json().response ) 
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err.json());
            }, () => {
                observer.complete();
            });
        }); 
    }
}


// WEBPACK FOOTER //
// ./src/services/project.service.ts